var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"loading-screen"}},[_c('div',{attrs:{"id":"loader"}},[_c('h2',[_vm._v("Loading in progress\n      "),_c('animated-number',{attrs:{"value":this.message.percent,"duration":this.message.duration,"formatValue":this.formatToPercent}})],1)])]),_vm._v(" "),_c('teaserInfo'),_vm._v(" "),_c('div',{attrs:{"id":this.name}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f055005","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainpage.vue
// module id = null
// module chunks = 